export const FEATURE_FLAGS = {
  VESSEL_SETTINGS_TURBO_CHARGER_RPM: true,
  NPE_TAGS_AUX_7_TO_10: false,
  DIESEL_GEN_DUAL_FUEL_SETTING: true,
  NUM_OF_PROPELLERS: true, // release 1.23.0
  LUBE_OIL_DEBUNKERING: true, // release 1.23.0
  PTO_SHAFT_GEN_RH_ROW: true, // release 1.23.0
  CLIENT_FUNCTIONALITY: false,
  DYNAMIC_POSITIONING_OPERATING_CODE: true, // release 1.23.0
  NO_CONSUMPTIONS_TO_REPORT: true, // release 1.23.0
  REPORT_PAGINATION: false,
  CARGO_PUMP_POWER_METER: false,
  FUEL_LUBE_DEBUNK_UPLOAD: false,
  REMOVE_EDIT_REPORT_IN_PROGRESS_NPE: false,
  ADD_FUELS_TO_ENGINE_REPORTS: false,
  GROSS_CARGO_WEIGHT: false,
};
